var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2446 1C21.5367 1 23.422 2.84377 23.5 5.16569V15.1275C23.5 17.4245 21.6129 19.2932 19.3033 19.2932L13.521 19.293L13.3405 19.6224C12.2948 21.4507 11.053 22.5079 9.7923 22.8985L9.6026 22.9523C8.63495 23.1921 7.68759 22.5024 7.68759 21.4879L7.687 19.293L4.69643 19.2932C2.45678 19.2932 0.61474 17.536 0.505157 15.3351L0.5 15.1275V5.16569C0.5 2.86865 2.3868 1 4.69643 1H19.2446ZM19.2446 3H4.69643C3.48706 3 2.5 3.97757 2.5 5.16569V15.1275C2.5 16.3156 3.48706 17.2932 4.69643 17.2932H8.15974C9.00313 17.2932 9.68759 17.971 9.68759 18.8159L9.687 20.775L9.77907 20.723C10.4171 20.3316 11.093 19.5902 11.7342 18.3958L11.8711 18.1329C12.1292 17.6216 12.6506 17.2932 13.233 17.2932H19.3033C20.5127 17.2932 21.5 16.3155 21.5 15.1275L21.5006 5.1995C21.4595 3.98396 20.4533 3 19.2446 3ZM11 11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H11ZM17 7C17.5523 7 18 7.44772 18 8C18 8.55228 17.5523 9 17 9H7C6.44772 9 6 8.55228 6 8C6 7.44772 6.44772 7 7 7H17Z",
    fill: "#232631"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.2c9cbb7fcf7472d1c80d3f4a7de2cea7.svg";
export { ForwardRef as ReactComponent };